export const actionType = {
  SET_HEADER_MENU_OPTIONS: "theme-customize/SET_HEADER_MENU_OPTIONS",
  SET_THEME_CONFIG: "theme-customize/SET_THEME_CONFIG",
  UPDATE_THEME_HEADER_MENU: "theme-customize/UPDATE_THEME_HEADER_MENU",
  UPDATE_THEME_HEADER_MENU_SCROLL_TYPE: "theme-customize/UPDATE_THEME_HEADER_MENU_SCROLL_TYPE",
  CLEAR_THEME_CONFIG: "theme-customize/CLEAR_THEME_CONFIG",
};
